import React from 'react';

const RUTA_COLECCION = '/recubrimientos-pisos'; // confirmar slug de la página de colección

// Mismo orden, nombres, imágenes y enlaces de CatalogoPisos.js
const pisos = [
  {
    img: '/assets/img/productos/pisos-spc-premium/Copia%20de%20piso-spc-luxury-ventajas.jpeg',
    alt: 'Pisos SPC Luxury',
    nombre: 'Pisos SPC Luxury',
    tipo: 'Para Interiores',
    link: '/pisos-spc-premium',
  },
  {
    img: '/assets/img/productos/pisos-vinilicos-lvt/piso-vinilico-intro.jpg',
    alt: 'Pisos Vinilicos LVT',
    nombre: 'Pisos Vinilicos LVT',
    tipo: 'Para Interiores',
    link: '/piso-vinilico-lvt-page',
  },
  {
    img: '/assets/img/productos/piso-deck-sintetico/piso-deck-sintetico-intro.jpg',
    alt: 'Piso Deck Sintético',
    nombre: 'Piso Deck Sintético',
    tipo: 'Para Interiores',
    link: '/piso-deck-sintetico-page',
  },
  {
    img: '/assets/img/productos/piso-de-pvc-rigido/piso-de-pvc-rigido-amarillo-atras.jpg',
    alt: 'Pisos de PVC Rigido',
    nombre: 'Pisos de PVC Rigido',
    tipo: 'Para Interiores',
    link: '/piso-de-pvc-rigido',
  },
  {
    img: '/assets/img/productos/piso-caucho-reciclado/piso-caucho-reciclado-intro.jpg',
    alt: 'Pisos de Caucho',
    nombre: 'Pisos de Caucho',
    tipo: 'Para Interiores',
    link: '/piso-de-caucho-page',
  },
  {
    img: '/assets/img/productos/piso-deck-wpc/deck-tablon-wpc-01.png',
    alt: 'Tablon Deck WPC',
    nombre: 'Tablon Deck WPC',
    tipo: 'Para Exteriores',
    link: '/deck-tablon-wpc',
  },
];

const CatalogoPisosHome = () => {
  return (
    <section id="pisos" className="dt-pisos dt-section">
      <div className="container">
        <div className="dt-head wow fadeIn" data-wow-delay="200ms">
          <div>
            <span className="dt-eyebrow">Pisos</span>
            <h2 className="h1 mb-0">Conoce nuestra colección de recubrimiento para pisos</h2>
          </div>
          <a className="dt-link" href={RUTA_COLECCION}>
            Ver todos los pisos <i className="fas fa-arrow-right" aria-hidden="true"></i>
          </a>
        </div>

        <div className="dt-pisos__grid">
          {pisos.map((p, i) => (
            <a
              key={p.link}
              href={p.link}
              className="dt-tile wow fadeInUp"
              data-wow-delay={`${(i % 3) * 100}ms`}
            >
              <img src={p.img} alt={p.alt} loading="lazy" />
              <span className="dt-tile__label">
                <span className="dt-tile__name">{p.nombre}</span>
                <span className="dt-tile__arrow"><i className="fas fa-arrow-right" aria-hidden="true"></i></span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CatalogoPisosHome;